
import Minus from '@/assets/svg/icons/minus.svg';
import Plus from '@/assets/svg/icons/plus.svg';
import ShapeEven from '@/assets/svg/icons/shape-even.svg';
import ShapeWide from '@/assets/svg/icons/shape-wide.svg';
import { TransformedCmExpandableLayer } from '@/transforms/transformModules';
import gsap from '~/plugins/gsap';
import Vue from 'vue';

export default Vue.extend({
  components: { ShapeEven, ShapeWide, Plus, Minus },
  props: {
    data: {
      type: Object as () => TransformedCmExpandableLayer['data'],
      required: true,
    },
  },
  data() {
    return {
      locale: this.$i18n.locale,
      currentLayerId: null as string | null,
    };
  },
  computed: {
    allLayers(): { id: string; modules: any[] }[] {
      return (this.data.gridItems ?? []).flatMap(item => item.layers);
    },
  },
  head(): any {
    if (this.$route.query.showLayer) {
      return {
        link: [
          {
            hid: 'canonical',
            rel: 'canonical',
            href: process.env.APP_URL + this.$route.fullPath,
          },
        ],
      };
    }
  },

  watch: {
    '$route.query': {
      handler() {
        this.syncLayerFromQuery();
      },
    },
  },
  mounted(): void {
    // Wait for the Modal's portal target to be mounted
    this.$nextTick(this.syncLayerFromQuery);
  },

  methods: {
    openLayer(layerId: string) {
      this.currentLayerId = layerId;
      document.body.classList.add('body-locked');
      gsap.config({ nullTargetWarn: false });
      setTimeout(() => {
        const expandedLayer = this.$refs.expandedLayer as HTMLElement | undefined;
        if (expandedLayer) {
          expandedLayer.scrollTop = 0;
        }
        gsap.set(['.cm-exp-layer__expanded-layer'], { yPercent: 100, opacity: 1 });
        gsap.to(['.cm-exp-layer__expanded-layer'], { yPercent: 0, ease: 'curveAppear', duration: 0.6, delay: 0.1 });
        gsap.to(['.cm-exp-layer__expanded-layer-bg'], { opacity: 0.5, ease: 'curveAppear', duration: 0.3 });
        gsap.to(['.cm-exp-layer__close-icon'], { opacity: 1, delay: 0.6 });
      }, 100);
    },

    closeLayer() {
      if (!this.currentLayerId) return;
      document.body.classList.remove('body-locked');
      this.removeLayerIdFromUrl();
      gsap.config({ nullTargetWarn: false });
      gsap.set(['.cm-exp-layer__close-icon'], { opacity: 0 });
      gsap.to(['.cm-exp-layer__expanded-layer'], { yPercent: 100, ease: 'curveAppear', duration: 0.4 });
      gsap.to(['.cm-exp-layer__expanded-layer-bg'], { opacity: 0, ease: 'curveAppear', duration: 0.3, delay: 0.1 });
      setTimeout(() => {
        this.currentLayerId = null;
      }, 400);
    },

    addLayerIdToUrl(layerId: string): void {
      const currentQuery = this.$route.query;
      this.$router.push({ query: { ...currentQuery, ...{ showLayer: layerId } } });
    },

    removeLayerIdFromUrl(): void {
      if (this.$route.query.showLayer) {
        const currentQuery = { ...this.$route.query };
        const newQuery = currentQuery;
        if (newQuery.formSent) delete newQuery.formSent;
        if (newQuery.success) delete newQuery.success;
        delete newQuery.showLayer;
        this.$router.push({ query: newQuery });
        history.replaceState(null, '');
      }
    },

    syncLayerFromQuery(): void {
      const showLayer = this.$route.query.showLayer;
      const matchingLayer = typeof showLayer === 'string' && this.allLayers.find(layer => layer.id === showLayer);
      if (matchingLayer) {
        this.openLayer(matchingLayer.id);
      } else {
        this.closeLayer();
      }
    },

    checkHeadlineMargin() {
      if (this.data.moduleHeader) {
        const headlineText = this.data.moduleHeader.headline.text?.trim() ?? '';
        if (headlineText.length === 0) {
          return 'no-margin-top';
        }
      }
    },
  },
});
